<template>
  <table style="table-layout: fixed; font-size: 14px" class="m-0 mx-auto pt-4">
    <tbody>
      <tr v-for="items in getOptionItems(product)" :key="items.title">
        <td class="border-right border-primary pr-3 py-1">
          {{ items.title }}
        </td>
        <td class="border-left border-primary pl-3 font-weight-bold">
          <div v-if="items.title == 'Sizes' && product.category_name == 'Pack To Order'">
            {{ pdpSizesAvailable(product) }}
          </div>
          <div v-else-if="typeof items.property !== 'function' && product[items.property] !== null">
            {{ product[items.property] }}
          </div>
          <div v-else-if="typeof items.property == 'function'">
            {{ items.property(product) }}
          </div>
          <div v-else>N/A</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { getUnit, getUnitSize, pdpSizesAvailable } from "@/services/storefront/storefront";

export default {
  props: {
    product: { type: Object, required: true },
  },
  data() {
    return {
      showSizes: false,
      options: [
        {
          name: "default",
          items: [
            { title: "Batch", property: "name" },
            { title: "Category", property: "category_name" },
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
          ],
        },
        {
          name: "Live Plant",
          items: [
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            { title: "Lineage", property: "lineage" },
            {
              title: "Flowering",
              property: "flowering_period",
            },
            {
              title: "Yield",
              property: (product) => {
                if (product.per_sq_ft_indoor) {
                  return `${product.per_sq_ft_indoor} Per sq ft`;
                }

                if (product.yields_per_acre_outdoor) {
                  return `${product.yields_per_acre_outdoor} Per Acre`;
                }

                return "N/A";
              },
            },
          ],
        },
        {
          name: "Seed",
          items: [
            { title: "Cultivar", property: "cultivar_name" },
            { title: "Lineage", property: "lineage" },
            {
              title: "Flowering",
              property: "flowering_period",
            },
            {
              title: "Yield",
              property: (product) => {
                if (product.per_sq_ft_indoor) {
                  return `${product.per_sq_ft_indoor} Per sq ft`;
                }

                if (product.yields_per_acre_outdoor) {
                  return `${product.yields_per_acre_outdoor} Per Acre`;
                }

                return "N/A";
              },
            },
          ],
        },
        {
          name: "Plant Material",
          items: [
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Grow Env",
              property: "grow_environment",
            },
            {
              title: "Trim Method",
              property: (product) => (product.trim_method ? product.trim_method : "N/A"),
            },
          ],
        },
        {
          name: "Flower",
          items: [
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Grow Env",
              property: "grow_environment",
            },
            {
              title: "Grow Medium",
              property: "grow_medium",
            },
            {
              title: "Trim Method",
              property: (product) => (product.trim_method ? product.trim_method : "N/A"),
            },
          ],
        },
        {
          name: "Bulk Extract",
          items: [
            { title: "Extract Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Container",
              property: "container_type",
            },
            {
              title: "Extraction Date",
              property: "extraction_date",
            },
          ],
        },
        {
          name: "Extract",
          items: [
            { title: "Extract Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Weight",
              property: (product) => getUnitSize(product),
            },
            {
              title: "Container",
              property: "container_type",
            },
            {
              title: "Extraction Date",
              property: "extraction_date",
            },
          ],
        },
        {
          name: "Tincture",
          items: [
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Carrier Oil",
              property: (product) => (product.infusionMethod ? product.infusionMethod : "N/A"),
            },
            { title: "Production Date", property: "production_date" },
          ],
        },
        {
          name: "Cartridge",
          items: [
            { title: "Cartridge Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Flavor",
              property: (product) => (product.flavor ? product.flavor : "N/A"),
            },
            {
              title: "Extraction Date",
              property: "extraction_date",
            },
          ],
        },
        {
          name: "Preroll",
          items: [
            { title: "Preroll Type", property: "product_type" },
            {
              title: "Grams Per Preroll",
              property: (product) => (product.gram_per_preroll ? `${product.gram_per_preroll} gram` : "N/A"),
            },
            {
              title: "Grow Env",
              property: "grow_environment",
            },
            {
              title: "Production Date",
              property: "production_date",
            },
          ],
        },
        {
          name: "Pack To Order",
          items: [
            { title: "Type", property: "product_type" },
            {
              title: "Sizes",
            },
            {
              title: "Grow Env",
              property: "grow_environment",
            },
            {
              title: "Trim Method",
              property: (product) => (product.trim_method ? product.trim_method : "N/A"),
            },
            {
              title: "Container",
              property: "container_type",
            },
          ],
        },
        {
          name: "Prepack",
          items: [
            { title: "Type", property: "product_type" },
            { title: "Cultivar", property: "cultivar_name" },
            {
              title: "Grow Env",
              property: "grow_environment",
            },
            {
              title: "Trim Method",
              property: (product) => (product.trim_method ? product.trim_method : "N/A"),
            },
            {
              title: "Container",
              property: "container_type",
            },
            { title: "Package Size", property: "packaged_unit_size" },
          ],
        },
        {
          name: "Topicals & Wellness",
          items: [
            { title: "Type", property: "product_type" },
            {
              title: "Carrier Oil",
              property: (product) => (product.infusionMethod ? product.infusionMethod : "N/A"),
            },
            {
              title: "Expiration Date",
              property: "best_by_date",
            },
          ],
        },
        {
          name: "Edibles & Drink",
          items: [
            { title: "Type", property: "product_type" },
            {
              title: "Carrier Oil",
              property: (product) => (product.infusionMethod ? product.infusionMethod : "N/A"),
            },
            {
              title: "Expiration Date",
              property: "best_by_date",
            },
          ],
        },
      ],
    };
  },
  methods: {
    getUnit,
    getUnitSize,
    pdpSizesAvailable,
    getOptionItems(product) {
      if (this.options.some((option) => option.name == product.category_name)) {
        return this.options.find((option) => option.name == product.category_name).items;
      }

      return this.options.find((option) => option.name == "default").items;
    },
  },
};
</script>
